// assets/variant-buttons.js
(function() {
  'use strict';
 
  console.log('🔵 VARIANT BUTTONS SCRIPT LOADED');
 
  // Store selected variants per product
  window.selectedVariants = window.selectedVariants || {};
 
  // ---------------------------------------------------------------------
  // Helper: Set default variant for a product
  // ---------------------------------------------------------------------
  function setDefaultVariantForProduct(productItem) {
    try {
      var productId = productItem.dataset.productId || productItem.getAttribute('data-product-id');
      if (!productId) return;
      
      // Check if a variant is already selected for this product
      if (window.selectedVariants[productId]) {
        // Already have a selection, keep it
        return;
      }
      
      // Find all variant buttons in this product
      var variantBtns = productItem.querySelectorAll('.variant-option-btn');
      if (variantBtns.length === 0) return;
      
      // Get the first variant as default
      var defaultBtn = variantBtns[0];
      var variantId = defaultBtn.dataset.variantId || defaultBtn.getAttribute('data-variant-id');
      var variantPrice = defaultBtn.dataset.variantPrice || defaultBtn.getAttribute('data-variant-price');
      var variantTitle = defaultBtn.dataset.variantTitle || defaultBtn.getAttribute('data-variant-title') || 'Default';
      
      if (!variantId) return;
      
      // Store the default variant
      window.selectedVariants[productId] = variantId;
      
      // Update the add button with default variant
      var addBtn = productItem.querySelector('[data-quick-add]');
      if (addBtn) {
        addBtn.dataset.selectedVariant = variantId;
        addBtn.dataset.productId = variantId;
        
        var textSpan = addBtn.querySelector('.product-item__quick-add-button-text');
        if (textSpan) {
          if (!addBtn.dataset.originalText) {
            addBtn.dataset.originalText = textSpan.textContent;
          }
          textSpan.textContent = 'Add ' + variantTitle;
        }
      }
      
      // Update price with default variant
      var priceWrapper = productItem.querySelector('.product-item__price-wrapper');
      if (priceWrapper) {
        var priceEl = priceWrapper.querySelector('[data-current-price]');
        if (priceEl && variantPrice) {
          var cleanPrice = variantPrice.replace(/\s*(AUD|USD|EUR|GBP|CAD|JPY|CHF|NZD|SGD|HKD|SEK|KRW|NOK|DKK|PLN|BRL|MXN|ZAR|INR|RUB|TRY|TWD|THB|MYR|PHP|IDR|VND)\s*$/i, '');
          priceEl.textContent = cleanPrice;
        }
      }
      
      // Visually select the first variant button
      var container = productItem.querySelector('.product-item__serving-size');
      if (container) {
        container.querySelectorAll('.variant-option-btn').forEach(function(b) {
          if (b === defaultBtn) {
            b.style.borderColor = '#285237';
            b.style.background = '#285237';
            b.style.color = '#ffffff';
            b.style.fontWeight = '600';
          } else {
            b.style.borderColor = '#d1d1d1';
            b.style.background = '#ffffff';
            b.style.color = '#285237';
            b.style.fontWeight = '500';
          }
        });
      }
      
      console.log('✅ Default variant set:', variantTitle, 'for product:', productId);
      
    } catch (error) {
      console.error('Error setting default variant:', error);
    }
  }
 
  // ---------------------------------------------------------------------
  // Variant selection
  // ---------------------------------------------------------------------
  window.selectVariantDirect = function(variantId, variantPrice, variantTitle, btn) {
    console.log('🔵 Variant selected:', variantTitle, variantId);
 
    try {
      var productItem = btn.closest('.product-item');
      if (!productItem) {
        console.warn('No product item found');
        return;
      }
 
      var productId = productItem.dataset.productId || productItem.getAttribute('data-product-id');
      if (!productId) {
        console.warn('No product ID found');
        return;
      }
 
      // Store selected variant
      window.selectedVariants[productId] = variantId;
 
      // Update all variant buttons in this product
      var container = btn.closest('.product-item__serving-size');
      if (container) {
        container.querySelectorAll('.variant-option-btn').forEach(function(b) {
          if (b === btn) {
            b.style.borderColor = '#285237';
            b.style.background = '#285237';
            b.style.color = '#ffffff';
            b.style.fontWeight = '600';
          } else {
            b.style.borderColor = '#d1d1d1';
            b.style.background = '#ffffff';
            b.style.color = '#285237';
            b.style.fontWeight = '500';
          }
        });
      }
 
      // Update the add button
      var addBtn = productItem.querySelector('[data-quick-add]');
      if (addBtn) {
        addBtn.dataset.selectedVariant = variantId;
        addBtn.dataset.productId = variantId;
 
        var textSpan = addBtn.querySelector('.product-item__quick-add-button-text');
        if (textSpan) {
          if (!addBtn.dataset.originalText) {
            addBtn.dataset.originalText = textSpan.textContent;
          }
          if (variantTitle) {
            textSpan.textContent = 'Add ' + variantTitle;
          }
        }
      }
 
      // Update price
      var priceWrapper = productItem.querySelector('.product-item__price-wrapper');
      if (priceWrapper) {
        var priceEl = priceWrapper.querySelector('[data-current-price]');
        if (priceEl && variantPrice) {
          var cleanPrice = variantPrice.replace(/\s*(AUD|USD|EUR|GBP|CAD|JPY|CHF|NZD|SGD|HKD|SEK|KRW|NOK|DKK|PLN|BRL|MXN|ZAR|INR|RUB|TRY|TWD|THB|MYR|PHP|IDR|VND)\s*$/i, '');
          priceEl.textContent = cleanPrice;
        }
      }
 
      console.log('✅ Variant stored:', variantId, 'for product:', productId);
 
    } catch (error) {
      console.error('Error selecting variant:', error);
    }
  };
 
  // ---------------------------------------------------------------------
  // Add to cart
  // ---------------------------------------------------------------------
  window.quickAddDirect = function(btn) {
    console.log('🛒 Quick add clicked');
 
    try {
      var productItem = btn.closest('.product-item');
      if (!productItem) {
        alert('Error: Could not find product');
        return;
      }
 
      var productId = productItem.dataset.productId || productItem.getAttribute('data-product-id');
      var variantId = btn.dataset.selectedVariant || btn.dataset.defaultVariant || btn.dataset.productId;
 
      console.log('Product ID:', productId, 'Variant ID:', variantId);
 
      // If we have variants, check if one is selected
      var hasVariants = productItem.querySelector('.product-item__serving-size .variant-option-btn');
      if (hasVariants) {
        var selected = window.selectedVariants[productId];
        if (selected) {
          variantId = selected;
        } else {
          // Try to set default variant if none selected
          setDefaultVariantForProduct(productItem);
          selected = window.selectedVariants[productId];
          if (selected) {
            variantId = selected;
          } else {
            alert('Please select a serving size first');
            return;
          }
        }
      }
 
      if (!variantId) {
        alert('Error: No variant selected');
        return;
      }
 
      // Get quantity
      var quantity = 1;
      var qtyInput = productItem.querySelector('[data-quantity-input]');
      if (qtyInput) {
        quantity = parseInt(qtyInput.value) || 1;
      }
 
      // Find the text span
      var textSpan = btn.querySelector('.product-item__quick-add-button-text');
      var originalText = btn.dataset.originalText || (textSpan ? textSpan.textContent : btn.textContent);
 
      // Show loading
      if (textSpan) {
        textSpan.textContent = 'Adding...';
      } else {
        btn.textContent = 'Adding...';
      }
      btn.classList.add('btn--loading');
 
      // Use XMLHttpRequest
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Accept', 'application/json');
 
      xhr.onload = function() {
        if (xhr.status === 200) {
          console.log('✅ Added to cart successfully');
 
          var cartXhr = new XMLHttpRequest();
          cartXhr.open('GET', '/cart.js', true);
          cartXhr.onload = function() {
            if (cartXhr.status === 200) {
              try {
                var cart = JSON.parse(cartXhr.responseText);
                console.log('Cart updated:', cart.item_count, 'items');
 
                var cartCount = document.querySelector('.header__cart-count');
                if (cartCount) {
                  cartCount.textContent = cart.item_count;
                }
 
                document.dispatchEvent(new CustomEvent('cart:updated', {
                  detail: { cart: cart }
                }));
 
              } catch(e) {
                console.warn('Error parsing cart response:', e);
              }
            }
 
            // Show success
            btn.classList.remove('btn--loading');
            btn.classList.add('btn--success');
            if (textSpan) {
              textSpan.textContent = 'Added!';
            } else {
              btn.textContent = 'Added!';
            }
 
            // Open cart drawer
            setTimeout(function() {
              var cartToggle = document.querySelector('[data-cart-toggle]');
              if (cartToggle) {
                cartToggle.click();
              } else {
                var cartIcon = document.querySelector('.header__cart-icon, .cart-icon, [data-cart-drawer-toggle]');
                if (cartIcon) {
                  cartIcon.click();
                }
              }
            }, 300);
 
            // Reset button
            setTimeout(function() {
              btn.classList.remove('btn--success');
              if (textSpan) {
                textSpan.textContent = originalText;
              } else {
                btn.textContent = originalText;
              }
            }, 2000);
          };
 
          cartXhr.onerror = function() {
            btn.classList.remove('btn--loading');
            btn.classList.add('btn--success');
            if (textSpan) {
              textSpan.textContent = 'Added!';
            } else {
              btn.textContent = 'Added!';
            }
 
            setTimeout(function() {
              btn.classList.remove('btn--success');
              if (textSpan) {
                textSpan.textContent = originalText;
              } else {
                btn.textContent = originalText;
              }
            }, 2000);
          };
 
          cartXhr.send();
 
        } else {
          try {
            var error = JSON.parse(xhr.responseText);
            throw new Error(error.description || 'Failed to add to cart');
          } catch(e) {
            throw new Error('Failed to add to cart (Status: ' + xhr.status + ')');
          }
        }
      };
 
      xhr.onerror = function() {
        console.error('Network error - request failed');
        btn.classList.remove('btn--loading');
        if (textSpan) {
          textSpan.textContent = originalText;
        } else {
          btn.textContent = originalText;
        }
        alert('Network error. Please check your connection and try again.');
      };
 
      xhr.send(JSON.stringify({
        id: parseInt(variantId),
        quantity: quantity
      }));
 
    } catch (error) {
      console.error('Error in quick add:', error);
      btn.classList.remove('btn--loading');
      alert('Error adding to cart: ' + error.message);
    }
  };
 
  // ---------------------------------------------------------------------
  // Height sync for the native hover quick-add overlay (--item-height)
  // ---------------------------------------------------------------------
  function syncItemHeights() {
    document.querySelectorAll('.product-item--has-quick-add .product-item__inner').forEach(function(inner) {
      var height = inner.getBoundingClientRect().height;
      if (height > 0) {
        inner.style.setProperty('--item-height', height + 'px');
      }
    });
  }
 
  var resizeTimer;
  function debouncedSync() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncItemHeights, 150);
  }
 
  // ---------------------------------------------------------------------
  // Init: fix variant button visibility + sync heights + set defaults
  // ---------------------------------------------------------------------
  function init() {
    console.log('🚀 Initializing variant buttons...');
 
    // Make all variant buttons visible
    document.querySelectorAll('.variant-option-btn').forEach(function(btn) {
      btn.style.display = 'inline-block';
      btn.style.visibility = 'visible';
      btn.style.opacity = '1';
      btn.style.pointerEvents = 'auto';
    });
 
    // Make serving size containers visible
    document.querySelectorAll('.product-item__serving-size').forEach(function(el) {
      el.style.display = 'block';
      el.style.visibility = 'visible';
      el.style.opacity = '1';
    });
 
    // Set default variant for each product
    document.querySelectorAll('.product-item').forEach(function(productItem) {
      setDefaultVariantForProduct(productItem);
    });
 
    // Recalculate hover-overlay heights now that variants are in flow
    syncItemHeights();
 
    console.log('✅ Variant buttons ready');
  }
 
  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(init, 100);
    });
  } else {
    setTimeout(init, 100);
  }
 
  // Run on Shopify section loads
  document.addEventListener('shopify:section:load', function() {
    setTimeout(init, 200);
  });
 
  // Re-measure on window load and resize (debounced)
  window.addEventListener('load', syncItemHeights);
  window.addEventListener('resize', debouncedSync);
 
  // Re-measure once images finish loading (aspect ratio affects card height)
  document.querySelectorAll('.product-item img').forEach(function(img) {
    if (img.complete) return;
    img.addEventListener('load', syncItemHeights, { once: true });
  });
 
  // Safety net in case fonts/late content shift heights
  setTimeout(syncItemHeights, 500);
  setTimeout(syncItemHeights, 1500);
 
  // MutationObserver for dynamic content (carousels, infinite scroll, AJAX filtering)
  if (window.MutationObserver) {
    var observer = new MutationObserver(function(mutations) {
      var shouldInit = false;
      var shouldSetDefaults = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              if (node.matches && (node.matches('.product-item') || node.querySelector('.product-item'))) {
                shouldInit = true;
                shouldSetDefaults = true;
              }
            }
          });
        }
      });
      
      if (shouldInit) {
        setTimeout(function() {
          init();
          if (shouldSetDefaults) {
            document.querySelectorAll('.product-item').forEach(function(productItem) {
              setDefaultVariantForProduct(productItem);
            });
          }
        }, 100);
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
 
  console.log('✅ Variant buttons script fully loaded');
})();